import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthContext';

export const UserbackSync = () => {
    const { currentUser } = useAuth();
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        const token = process.env.REACT_APP_USERBACK_TOKEN;
        if (!token) {
            console.warn('Userback-Token fehlt in .env (REACT_APP_USERBACK_TOKEN)');
            return;
        }

        // Userback-Objekt vorbereiten
        window.Userback = window.Userback || {};
        window.Userback.access_token = token;

        // Skript dynamisch laden
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://static.userback.io/widget/v1.js';
        script.onload = () => {
            console.log('✅ Userback-Skript geladen');
            // Kurze Verzögerung, bis das Widget intern initialisiert ist
            setTimeout(() => {
                if (window.Userback && typeof window.Userback.setUserData === 'function') {
                    setIsReady(true);
                    console.log('✅ Userback bereit');
                } else {
                    console.warn('⚠️ Userback.setUserData nicht verfügbar');
                }
            }, 500);
        };
        script.onerror = () => {
            console.error('❌ Userback-Skript konnte nicht geladen werden');
        };
        document.body.appendChild(script);
    }, []); // nur einmal beim Start

    // Benutzerdaten setzen, sobald Widget bereit ist und Benutzer sich ändert
    useEffect(() => {
        if (!isReady || !window.Userback) return;

        // Typprüfung für TypeScript
        const setUserData = window.Userback.setUserData;
        if (typeof setUserData !== 'function') {
            console.warn('Userback.setUserData ist keine Funktion');
            return;
        }

        if (currentUser && currentUser.emailVerified) {
            setUserData({
                id: currentUser.uid,
                info: {
                    name: currentUser.displayName || currentUser.email?.split('@')[0] || 'User',
                    email: currentUser.email || '',
                },
            });
            console.log('✅ Userback-Benutzerdaten gesetzt');
        } else {
            setUserData(null);
        }
    }, [currentUser, isReady]);

    return null;
};